// URL utilities
export function getImageUrl(path: string, baseUrl?: string): string {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  const base = baseUrl || process.env.NEXT_PUBLIC_CDN_URL || "";
  return `${base}${path.startsWith("/") ? "" : "/"}${path}`;
}

export function buildQueryString(params: Record<string, unknown>): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== "") {
          searchParams.append(`${key}[]`, String(item));
        }
      });
    } else if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, String(value));
    }
  });

  return searchParams.toString();
}

// Helper functions to safely encode/decode URL parameters
export const safeDecodeURIComponent = (str: string | null) => {
  if (!str) return "";
  try {
    return decodeURIComponent(str);
  } catch {
    return str;
  }
};

export const safeEncodeURIComponent = (str: string) => {
  if (!str) return "";
  try {
    const decoded = decodeURIComponent(str);
    return decoded === str ? encodeURIComponent(str) : str;
  } catch {
    return encodeURIComponent(str);
  }
};

export const s3URLToDNSURL = (s3URL: string) => {
  if (!s3URL) {
    return "";
  }
  return s3URL.replace(
      "https://secondsense-listings.s3.amazonaws.com/",
      "https://images.secondsense.co/"
  );
};